import React, { useEffect, useState } from "react";
import ReactMarkdown from "react-markdown";
import removeComments from "remark-remove-comments";
import { useTranslation } from "react-i18next";
import { getContentPath, loadMarkdownContent } from "../../../../utils/contentLoader";
import "./Frame1.scss";

function Frame1() {
  const { i18n } = useTranslation();
  const [frontMatter, setFrontMatter] = useState({});
  const [content, setContent] = useState("");

  useEffect(() => {
    let isMounted = true;

    const loadContent = async () => {
      try {
        const filePath = getContentPath("/content/_index", i18n.language);
        const { frontMatter: data, content: markdownContent } = await loadMarkdownContent(filePath);
        
        if (isMounted) {
          setFrontMatter(data);
          setContent(markdownContent);
        }
      } catch (e) {
        if (isMounted) {
          setFrontMatter((prev) => prev || {});
          setContent((prev) => prev || "");
        }
      }
    };

    loadContent();
    return () => {
      isMounted = false;
    };
  }, [i18n.language]);

  return (
    <section className="frame1" aria-labelledby="home-hero-title">
      <div className="frame1-inner">
        <div className="frame1TitleDiv">
          <h1 id="home-hero-title" className="frame1TitleName">
            {frontMatter.title}
          </h1>
        </div>

        <div className="descriptionDiv">
          <div className="frame1NetappDescription">
            <ReactMarkdown remarkPlugins={[removeComments]}>
              {content}
            </ReactMarkdown>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Frame1;